const Paths = {
  Basename: 'admin',
  BasePath: '/admin',
};
export default Paths;
